<template>
  <div id="contenedor-main-infraestructura-configuracion-tipos-infraestructura">
    <tool-bar
      v-on:nuevoTipoInfraestructura="agregarNuevoTipoInfraestructura">
    </tool-bar>
    <v-container
      fluid>
      <v-card
        flat>
        <v-card-text>
          <listado
            :listadoTiposInfraestructura="getTiposInfraestructura">
          </listado>
        </v-card-text>
      </v-card>
    </v-container>
    <!-- Ventana Agregar Tipo Infraestructura -->
    <v-dialog
      v-if="mostrarVentanaAgregarTipoInfraestructura"
      v-model="mostrarVentanaAgregarTipoInfraestructura"
      persistent
      width="600">
      <agregar-tipo-infraestructura
      v-on:cerrar="cerrarVentana">
      </agregar-tipo-infraestructura>
    </v-dialog>
    <!-- Ventana Editar Tipo Infraestructura -->
    <v-dialog
      v-if="esteTipoInfraestructura"
      v-model="mostrarVentanaEditarTipoInfraestructura"
      scrollable
      persistent
      width="600">
      <editar-tipo-infraestructura
      :tipoInfraestructuraEditar="esteTipoInfraestructura"
      v-on:cerrar="cerrarVentana">
      </editar-tipo-infraestructura>
    </v-dialog>
    <!-- Ventana Eliminar Tipo Infraestructura -->
    <v-dialog
      v-if="esteTipoInfraestructura"
      v-model="mostrarVentanaEiminarTipoInfraestructura"
      scrollable
      persistent
      width="400">
      <eliminar-tipo-infraestructura
      :tipoInfraestructuraEliminar="esteTipoInfraestructura"
      v-on:cerrar="cerrarVentana">
      </eliminar-tipo-infraestructura>
    </v-dialog>
  </div>
</template>

<script>
import CATALOGO_INFRAESTRUCTURA_TIPOS from '@/graphql/querys/administracion/catalogos/infraestructurastipos/catalogoInfraestructuraTipos.gql';
import ToolBar from './ToolBar.vue';
// import CustomButton from '@/components/buttons/Button.vue';
import AgregarTipoInfraestructura from '@/components/administracion/infraestructura/configuracion/tiposinfraestructura/Nuevo.vue';
import EditarTipoInfraestructura from '@/components/administracion/infraestructura/configuracion/tiposinfraestructura/Editar.vue';
import EliminarTipoInfraestructura from '@/components/administracion/infraestructura/configuracion/tiposinfraestructura/Eliminar.vue';
import Listado from './listado/Main.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'MainInfraestructuraConfiguracionTiposInfraestructura',
  components: {
    ToolBar,
    AgregarTipoInfraestructura,
    EditarTipoInfraestructura,
    EliminarTipoInfraestructura,
    Listado,
  },
  data() {
    return {
      mostrarVentanaAgregarTipoInfraestructura: false,
      mostrarVentanaEditarTipoInfraestructura: false,
      mostrarVentanaEiminarTipoInfraestructura: false,
      esteTipoInfraestructura: null,
    };
  },
  mounted() {
    eventBus.$on('editar-tipo-infraestructura', (tipoInfraestructura) => {
      this.mostrarVentanaEditarTipoInfraestructura = true;
      this.esteTipoInfraestructura = tipoInfraestructura;
    });
    eventBus.$on('eliminar-tipo-infraestructura', (tipoInfraestructura) => {
      this.mostrarVentanaEiminarTipoInfraestructura = true;
      this.esteTipoInfraestructura = tipoInfraestructura;
    });
  },
  methods: {
    cerrarVentana() {
      this.mostrarVentanaAgregarTipoInfraestructura = false;
      this.mostrarVentanaEditarTipoInfraestructura = false;
      this.mostrarVentanaEiminarTipoInfraestructura = false;
      this.esteTipoInfraestructura = null;
    },
    agregarNuevoTipoInfraestructura() {
      this.mostrarVentanaAgregarTipoInfraestructura = true;
    },
  },
  apollo: {
    catalogoInfraestructuraTipos: {
      query: CATALOGO_INFRAESTRUCTURA_TIPOS,
    },
  },
  computed: {
    getTiposInfraestructura() {
      if (!this.catalogoInfraestructuraTipos) return [];
      return this.catalogoInfraestructuraTipos;
    },
  },
};
</script>

<style lang="scss">

</style>
